export const airportPermission = [
  {
    integrationType: "Booking.com",
     permissionP2P: true,
  },
  {
    integrationType: "WorldTransfer.com",
     permissionP2P: true,
  },
  {
    integrationType: "Trip.com",
    permissionP2P: true,
  },
  {
    integrationType: "Mozio",
    permissionP2P: false,
  },
];
